import { RoleAssignmentState, roleAssignmentAdapter } from "@organizations/models";
import { createReducer, on } from "@ngrx/store";
import * as RoleAssignmentActions from "@organizations/store/actions";

const initialState: RoleAssignmentState = {
  ...roleAssignmentAdapter.getInitialState(),
  loaded: false,
  loading: false
};

export const reducer = createReducer(
  initialState,

  on(RoleAssignmentActions.loadRoleAssignments, (state): RoleAssignmentState => ({
    ...state,
    loading: true,
    loaded: false
  })),
  on(
    RoleAssignmentActions.loadRoleAssignmentsSuccess,
    (state, { roleAssignments }): RoleAssignmentState =>
      roleAssignmentAdapter.setMany(roleAssignments, {
        ...state,
        loading: false,
        loaded: true
      })
  ),
  on(RoleAssignmentActions.loadRoleAssignmentsFailure, (state): RoleAssignmentState => ({
    ...state,
    loading: false,
    loaded: false
  })),

  on(RoleAssignmentActions.deleteRoleAssignment, (state): RoleAssignmentState => ({
    ...state,
    loading: true
  })),
  on(
    RoleAssignmentActions.deleteRoleAssignmentSuccess,
    (state, { roleAssignmentId }): RoleAssignmentState =>
      roleAssignmentAdapter.removeOne(roleAssignmentId, {
        ...state,
        loading: false
      })
  ),
  on(RoleAssignmentActions.deleteRoleAssignmentFailure, (state): RoleAssignmentState => ({
    ...state,
    loading: false
  })),

  on(RoleAssignmentActions.createRoleAssignment, (state): RoleAssignmentState => ({
    ...state,
    loading: true
  })),
  on(
    RoleAssignmentActions.createRoleAssignmentSuccess,
    (state, { roleAssignment }): RoleAssignmentState =>
      roleAssignmentAdapter.addOne(roleAssignment, {
        ...state,
        loading: false
      })
  ),
  on(RoleAssignmentActions.createRoleAssignmentFailure, (state): RoleAssignmentState => ({
    ...state,
    loading: false
  }))
);

export const getRoleAssignmentsLoading = (state: RoleAssignmentState) => state.loading;
export const getRoleAssignmentsLoaded = (state: RoleAssignmentState) => state.loaded;
